import { RadioGroup } from '@mui/material';

import LabeledRadio from '../../generic/Forms/LabeledRadio';

export type OrgPickerOption = {
  value: number;
  label: string;
  secondaryLabel?: string;
};

type AuthFormOrgPickerProps = {
  options: OrgPickerOption[];
  selectedValue: number | null;
  onSelect: (value: number) => void;
};

const OptionLabel = ({ label, secondaryLabel }: Pick<OrgPickerOption, 'label' | 'secondaryLabel'>) => (
  <span className="fossa-auth__form__org-picker__option">
    <span>{label}</span>
    {secondaryLabel && (
      <small className="fossa-auth__form__org-picker__option-secondary">{secondaryLabel}</small>
    )}
  </span>
);

const AuthFormOrgPicker = ({
  options,
  selectedValue,
  onSelect,
}: AuthFormOrgPickerProps) => (
  <fieldset className="fossa-auth__form__org-picker">
    <legend className="fossa-auth__form__org-picker__legend">
      You have access to multiple organizations. Choose one to continue:
    </legend>
    <RadioGroup
      name="login-org-picker"
      value={selectedValue == null ? '' : String(selectedValue)}
      onChange={(_event, value) => onSelect(Number(value))}
    >
      {options.map(option => (
        <LabeledRadio
          key={option.value}
          value={String(option.value)}
          label={<OptionLabel label={option.label} secondaryLabel={option.secondaryLabel} />}
        />
      ))}
    </RadioGroup>
  </fieldset>
);

export default AuthFormOrgPicker;
